import {
  SHOW_ALERT,
  HIDE_ALERT,
  HEADER_READY,
  BODY_READY,
  OK_BUTTON_TEXT_READY,
  CANCEL_BUTTON_TEXT_READY,
  HIDE_CLOSE_BUTTON_READY,
  CALLBACK_READY
} from './ModalAlert.actions'

const initialState = {
  isOpen: false,
  hideCloseButton: false,
  header: 'Header Text',
  body: 'Body Goes Here',
  okButtonText: 'Ok',
  cancelButtonText: 'Cancel',
  callback: undefined
}

const currentState = (state = initialState, action) => {
  switch(action.type) {
    case SHOW_ALERT:
      return {
        ...state,
        isOpen: true
      }
    case HIDE_ALERT:
      return {
        ...state,
        isOpen: false
      }
    case HEADER_READY:
      return {
        ...state,
        header: action.payload
      }
    case BODY_READY:
      return {
        ...state,
        body: action.payload
      }
    case OK_BUTTON_TEXT_READY:
      return {
        ...state,
        okButtonText: action.payload
      }
    case CANCEL_BUTTON_TEXT_READY:
      return {
        ...state,
        cancelButtonText: action.payload
      }
    case HIDE_CLOSE_BUTTON_READY:
      return {
        ...state,
        hideCloseButton: action.payload
      }
    case CALLBACK_READY:
      return {
        ...state,
        callback: action.payload
      }
    default:
      return state
  }
}

export default currentState;